var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11777_791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95022 2.54933L11.4508 6.04987L3.84948 13.6512L0.728461 13.9957C0.310649 14.0419 -0.0423593 13.6886 0.00412509 13.2708L0.351391 10.1476L7.95022 2.54933ZM13.6158 2.02815L11.9722 0.384521C11.4595 -0.128174 10.628 -0.128174 10.1153 0.384521L8.56901 1.93081L12.0696 5.43136L13.6158 3.88507C14.1285 3.3721 14.1285 2.54085 13.6158 2.02815Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11777_791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d333ee418b3f8ed2c3d30b725a2871b6.svg";
export { ForwardRef as ReactComponent };